module.exports = __webpack_public_path__ + "img/web_nine_grids_4.6358e628.jpg";